
import i18n from '../assets/i18n'
import store from '@/store';
import Vue from 'vue'
let  bus=new Vue()

/**
 * 通用js方法封装处理
 * Copyright (c) 2019 sczn
 */

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

//倒计时 
export function timeCountDown(date,text='view.已超时', callback = () => {},clearFunction = ()=>{}){
  var time = '';
  const formatNumber = (n)=>{
    n = n.toString();
    return n[1] ? n : '0' + n;
  };
  const setTime = ()=>{
    const leftTime = new Date(date.replace(/\-/g, '/')) - new Date();
    if (leftTime >= 0) {
      const d = Math.floor(leftTime / 1000 / 60 / 60 / 24),
          h = Math.floor(leftTime / 1000 / 60 / 60 % 24),
          m = Math.floor(leftTime / 1000 / 60 % 60),
          s = Math.floor(leftTime / 1000 % 60);
      time = `${ d > 0 ? d + ' 天 ' : '' }${ [h, m, s].map(formatNumber).join(' : ') }`;
      callback(time, () => clearInterval(timer));
    } else {
      time =i18n.t(text) 
      clearInterval(timer)
      clearFunction(time)
      return
    }
  };
  const timer = setInterval(() => {
    setTime()
  }, 1e3);
}
// 金额转换
export function convertCurrency(amount,cnIntLast){
  var prefix = "";
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  var cnIntRadice = new Array('', '拾', '佰', '仟');
  var cnIntUnits = new Array('', '万', '亿', '兆');
  var cnDecUnits = new Array('角', '分', '毫', '厘');
  var cnInteger = '整';
  var cnIntLast =cnIntLast?cnIntLast:'元';
  
  var integerNum;
  var decimalNum; 
  var chineseStr = '';  
  var parts;  
  if(amount < 0){ 
      amount = -1 * amount; 
      prefix = "负";
  }
  if (amount == '') { return ''; }  
  amount = parseFloat(amount);  
  if (amount >= 999999999999999.9999) { 
      return '';  
  }  
  if (amount == 0) {  
      chineseStr = cnNums[0] + cnIntLast + cnInteger;  
      return chineseStr;  
  } 
  amount = amount.toString();  
  if (amount.indexOf('.') == -1) {  
      integerNum = amount;  
      decimalNum = '';  
  } else {  
      parts = amount.split('.');  
      integerNum = parts[0];  
      decimalNum = parts[1].substr(0, 4);  
  } 
  if (parseInt(integerNum, 10) > 0) {  
      var zeroCount = 0;  
      var IntLen = integerNum.length;  
      for (var i = 0; i < IntLen; i++) {  
          var n = integerNum.substr(i, 1);  
          var p = IntLen - i - 1;  
          var q = p / 4;  
          var m = p % 4;  
          if (n == '0') {  
              zeroCount++;  
          } else {  
              if (zeroCount > 0) {  
                  chineseStr += cnNums[0];  
              } 
              zeroCount = 0;  
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];  
          }  
          if (m == 0 && zeroCount < 4) {  
              chineseStr += cnIntUnits[q];  
          }  
      }  
      chineseStr += cnIntLast;  
  } 
  if (decimalNum != '') {  
      var decLen = decimalNum.length;  
      for (var i = 0; i < decLen; i++) {  
          var n = decimalNum.substr(i, 1);  
          if (n != '0') {  
              chineseStr += cnNums[Number(n)] + cnDecUnits[i];  
          }  
      }  
  }  
  if (chineseStr == '') {  
      chineseStr += cnNums[0] + cnIntLast + cnInteger;  
  } else if (decimalNum == '') {  
      chineseStr += cnInteger;  
  } else if (/角$/.test(chineseStr)) {  
      chineseStr += cnInteger;  
  }  
  chineseStr = prefix+chineseStr;
  return chineseStr;
}
// 阿拉伯数字转大写
export function arabicToChinese(num) {
  const numStr = num.toString();
  const digitArr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const unitArr = ['', '十', '百', '千', '万', '亿'];
  let chineseStr = '';

  for (var i = 0; i < numStr.length; i++) {
    var digit = Number(numStr[i]);
    var unit = unitArr[numStr.length - i - 1];
    chineseStr += digitArr[digit] + unit;
  }

  chineseStr = chineseStr.replace(/零./g, '零').replace(/零+/g, '零').replace(/零$/, '');
  chineseStr = chineseStr.replace(/^一十/, '十');

  return chineseStr;
}


// 字典项回显
export function getStatus(list,val,type){
  // type 对应需要回显的字段
  let a= ''
  type=type?type:'dictLabel'
  this[list].map(e=>{if(e.dictValue==val)a=e[type]})
  return a
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof (propName) === 'undefined') {
    search.params['beginTime'] = dateRange[0];
    search.params['endTime'] = dateRange[1];
  } else {
    search.params['begin' + propName] = dateRange[0];
    search.params['end' + propName] = dateRange[1];
  }
  return search;
}


// 回显数据字典
export function selectDictLabel(datas, value) {
  if (value === undefined) {
    return "";
  }
  var actions = [];
  Object.keys(datas).some((key) => {
    if (datas[key].value == ('' + value)) {
      actions.push(datas[key].label);
      return true;
    }
  })
  if (actions.length === 0) {
    actions.push(value);
  }
  return actions.join('');
}

// 回显数据字典（字符串、数组）
export function selectDictLabels(datas, value, separator) {
  if (value === undefined || value.length ===0) {
    return "";
  }
  if (Array.isArray(value)) {
    value = value.join(",");
  }
  var actions = [];
  var currentSeparator = undefined === separator ? "," : separator;
  var temp = value.split(currentSeparator);
  Object.keys(value.split(currentSeparator)).some((val) => {
    var match = false;
    Object.keys(datas).some((key) => {
      if (datas[key].value == ('' + temp[val])) {
        actions.push(datas[key].label + currentSeparator);
        match = true;
      }
    })
    if (!match) {
      actions.push(temp[val] + currentSeparator);
    }
  })
  return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
  var args = arguments, flag = true, i = 1;
  str = str.replace(/%s/g, function () {
    var arg = args[i++];
    if (typeof arg === 'undefined') {
      flag = false;
      return '';
    }
    return arg;
  });
  return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return "";
  }
  return str;
}

// 数据合并
export function mergeRecursive(source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p]);
      } else {
        source[p] = target[p];
      }
    } catch (e) {
      source[p] = target[p];
    }
  }
  return source;
};

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

// 验证是否为blob格式
export function blobValidate(data) {
  return data.type !== 'application/json'
}

// 文件大小格式转换
export function bytesToSize(size) {
  if (size < 0.1 * 1024) {
    //小于0.1KB，则转化成B
    size = size.toFixed(2) + 'B'
  } else if (size < 0.1 * 1024 * 1024) {
    // 小于0.1MB，则转化成KB
    size = (size / 1024).toFixed(2) + 'KB'
  } else if (size < 0.1 * 1024 * 1024 * 1024) {
    // 小于0.1GB，则转化成MB
    size = (size / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    // 其他转化成GB
    size = (size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }
 
  // 转成字符串
  let sizeStr = size + '',
    // 获取小数点处的索引
    index = sizeStr.indexOf('.'),
    // 获取小数点后两位的值
    dou = sizeStr.substr(index + 1, 2)
 
  // 判断后两位是否为00，如果是则删除00
  if (dou == '00')
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
 
  return size
}



export function handleClick() {
  let list = store.state.user.guidanceList
  // 阻止点击事件进一步传播，不加的话指引打开会关闭
  // e.stopPropagation();
  // 初始化
  const driver = new this.Driver(this.driverOptions);
  let index = list.findIndex(item => item.current === true)
  driver.defineSteps(list.map(item => stepDefinition(item.guidePosition, item.title, item.operationDescription,item.pagePosition)));
  // 开始进行向导，默认从0开始也就是步骤1，也可以自己调整其他步骤（0可以不写）
  driver.start(index);
}
export function stepDefinition(id, title, description,pagePosition) {
  // console.log('aa',id,title)
  return {
    element: '#' + id, // 要突出显示的查询选择器字符串或节点
    // stageBackground: '#ffffff',   // 这将覆盖在驱动程序中设置的
    popover: {
      // 如果为空或未指定弹窗，则不会有弹窗
      className: "popover-class", // 除了驱动程序选项中的一般类名外，还要包装这个特定步骤弹出窗口
      title: title, // popover 标题
      description:'<div style="max-height: 30vh;overflow-y: auto;">'+description+'</div>' , // popover 描述
      position:pagePosition,
    },
    onNext: () => {
      let list = store.state.user.guidanceList
      let index = list.findIndex(item => item.current === true)
      const isLastStep = index === list.length - 1
      if (isLastStep) {
        // ✅ 最后一步 = 确定
        store.dispatch('startDialogMd',true)
        console.log('aaa确定')

      }else{
        index++
        store.dispatch('HandleGuidanceList', { list: list, current: index })
        // 从当前步骤移动到下一步时调用
        bus.$emit(list[index].guidePosition == 'menu' ? 'start-guide-menu' : list[index].guidePosition == 'userImg'?'start-guide-login' :'start-guide-home');
      }
      
    },
    onPrevious: () => {
      // 从当前步骤移动到上一步时调用
      let list =store.state.user.guidanceList
      let index = list.findIndex(item => item.current === true)
      index--
      store.dispatch('HandleGuidanceList', { list: list, current: index })
      bus.$emit(list[index].guidePosition == 'menu' ? 'start-guide-menu' :  list[index].guidePosition == 'userImg'?'start-guide-login':'start-guide-home');
    },

  };
}

// 金钱格式化
export function formatNum(num) {
  // 空值（undefined/null/空字符串）直接返回原值，注意 0 不做拦截
  if (num === undefined || num === null || num === '') return ''
  // 传入的是无法转成数字的文本，直接返回原值
  if (isNaN(Number(num))) return num
  num = num.toString();
  // 分离正负号，便于后续校验与千分位处理
  let sign = '';
  if (num.charAt(0) === '-') {
    sign = '-';
    num = num.slice(1);
  }
  let text = num.replace(/\./g, '')
  if(!/^\d+$/.test(text)){
      return (sign ? '-' : '') + num
  }
  const numStr = num.toString().split('.'); //先转为字符串，再分开整数和小数部分
  let numInt = numStr[0]; // 整数部分
  // 小数部分：只有原数字存在小数点的时候，分割完长度才会大于1
  let numDec = numStr.length > 1 ? '.'+numStr[1] : '';
  // 有小数才补 0 到 4 位，没有小数（整数）则不显示小数位
  if(numDec && numDec.length < 4)
  while (4 - numDec.length)  numDec += '0';  //补0，有小数的情况下补到 4 位
  let resultInt = ''; //存储整数部分处理结果
  while (numInt.length > 3) {     //当剩余整数部分长度大于3时继续处理
      resultInt = ','+numInt.slice(-3)+resultInt;  //把后三位截出来，和处理结果拼在一起，前面加逗号
      numInt = numInt.slice(0, -3); // 剩下的部分是除去刚刚截掉的3位的部分
  }
  
  return sign + numInt + resultInt + numDec; //结果是“符号+剩余的不足3位的整数”+“处理好的整数结果”+“小数部分”
}
